import { getAnalyticsAdapter } from "./provider";

const adapter = getAnalyticsAdapter();

export const analytics = {
  page: adapter.page.bind(adapter),
  track: adapter.track.bind(adapter),
  identify: adapter.identify.bind(adapter),
  reset: adapter.reset.bind(adapter),
};


